import React from 'react';
import styled from 'styled-components';

import { LoadingSpinner } from 'common/components/icons';

interface IProps {
    className?: string;
}

const BaseLoadingOverlay: React.FC<IProps> = ({ children, className }) => (
    <div className={className}>
        <LoadingSpinner />
        <p>{children}</p>
    </div>
);

export const LoadingOverlay = styled(BaseLoadingOverlay)`
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.palette.primary.main};

    ${LoadingSpinner} {
        width: 80px;
        height: 80px;
        stroke: ${({ theme }) => theme.palette.primary.main};
    }
`;
